var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper"},[_c('div',{staticClass:"app header-fixed footer-fixed sidebar-fixed",attrs:{"id":"app"}},[_c('shared-header'),_c('shared-menu'),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }